import { Element } from "@xmpp/xml"
import { MessageDisplayType, Fasten } from "../reducers/messagesSlice"
import MessageParser from "./messageParser"

const parseXmppBoolean = (value: string): boolean =>
  ["1", "true"].includes(value)

export default class FastenParser {
  static parse(stanza: Element, timestamp?: string): Fasten | undefined {
    const fastenNode = stanza.getChild("apply-to")

    if (!fastenNode) return

    const children = fastenNode.children.filter(
      (child) => child instanceof Element,
    ) as Element[]
    const child = children[0]

    let fastensWith: Fasten["fastensWith"] | null = null
    let payload: Fasten["payload"] | null = null

    if (child.name === "route-update") {
      fastensWith = "RouteUpdated"
      payload = child.getChildren("stop-update").map((stopUpdate) => {
        return {
          result: stopUpdate.attrs.result,
          address: stopUpdate.attrs.address,
          is_approximate: parseXmppBoolean(stopUpdate.attrs.is_approximate),
          action: stopUpdate.attrs.action,
        }
      })
    } else if (child.name === "route-unchanged") {
      fastensWith = "RouteUnchanged"
    }

    if (!fastensWith) return

    return {
      id: MessageParser.id(stanza, false),
      to: stanza.attrs.to,
      from: stanza.attrs.from,
      messageId: fastenNode.attrs["id"],
      fastensWith,
      payload,
      timestamp: timestamp || new Date().toISOString(),
      displayType: MessageDisplayType.Fasten,
      type: stanza.attrs.type,
    }
  }
}
